
export const VARS ={
    Current_Project : null,
    selectedObs : {},
    segDrag : null,
    obsDrag : null,
    measurementLabelCounter : 1,
    setbackLabelCounter : 1,
    keyListener : null,
    mapTile : null,
    Meshes : [],
    isVertexDragActive: false, // Flag to track if vertex drag mode is active
    copiedObstacle: null, //data only
    copiedSegment: null, // for segment copy-paste
    copiedPanel: null, // panel copy/paste payload (one or multiple panels)
    clipboardType: null,
    mouseNDC: { x: 0, y: 0 }, // Normalized Device Coordinates of the mouse
    selectedTree: null, // currently selected tree, if any
    selectedSphere: null, // currently selected excluder (trim sphere), if any
    modelLoaded: false // true once the glTF and all its textures have finished
}


export const MODEL_LOADED_EVENT = "MODEL_LOADED";

export function resetModelLoaded() {
    VARS.modelLoaded = false;
}

export function markModelLoaded() {
    if (VARS.modelLoaded) return;
    VARS.modelLoaded = true;
    if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent(MODEL_LOADED_EVENT));
    }
}

// Runs `callback` once the model is ready, firing immediately if it already is.
// Returns an unsubscribe function.
export function onModelLoaded(callback) {
    if (VARS.modelLoaded) {
        callback();
        return () => {};
    }
    if (typeof window === "undefined") return () => {};
    window.addEventListener(MODEL_LOADED_EVENT, callback, { once: true });
    return () => window.removeEventListener(MODEL_LOADED_EVENT, callback);
}
export const DXF_VARS ={
    isVerticalFlipped :false,
    rotationAngle: null,
    vectorU : null,
    vectorV: null,
    origin : null,
    dormerData: [],
}
export const DrawingModes = {
    SEGMENT: 'SEGMENT',
    OBSTACLE: 'OBSTACLE',
    RULER: 'RULER',
    TRIM: 'TRIM',
    PANEL: 'PANEL',
    NONE: 'NONE',
};

export const ObstacleTypes = {
    RECTANGLE: 'RECTANGLE',
    CIRCLE: 'CIRCLE',
    POLYGON: 'POLYGON',
};

export const DrawingGlobals ={
    intersectionPoints:[],
    lineMeshes:[],
    verticesMesh:[],
}
export const RENDER_LAYERS = {
    ROOF_BASE: 1,
    IRRADIANCE: 3,
    OBSTACLE: 20,
    OBSTACLE_OUTLINE: 21,
    PANEL: 30,
    PANEL_OUTLINE: 31,
    OBSTACLE_OCCLUDER: 40,
}
export const LABELS ={
    measurements : [],
    angle : null,
    length: null,
}
export let POLYGONS =[];
export let VERTICES =[];
export let HISTORY = [];

export let TREESPHERES = {
    spheres:[],
    trimmedSections:[]
};

export const TREES = {
  trees: [],
};
